import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from "element-ui";
import util from "@/libs/util.js";
import router from "@/router";
import store from "@/store/index";
import watermark from "@/utils/watermark";
import { updateUserState } from "@/api/auth/onlineUser";
import { getUserProd } from "@/api/gmtool/packageCode";
import { getUserMenu } from "@/api/user";
import { menuAside, menuHeader } from "@/menu";
import { login as _login, getInfo, screenDataGet } from "@/api/user";
import { Loading } from "element-ui";
import { useryjenvlist } from "@/api/gmToolNew/gmToolNew";
export default {
  namespaced: true,
  state: {
    token: util.cookies.get("token"),
    name: "",
    avatar: "",
    introduction: "",
    roles: [],
    menu: []
  },
  actions: {
    // 重置路由
    ResetRoute: function ResetRoute(_ref) {
      var _this = this;

      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var loading = Loading.service({
        lock: true,
        text: "重置中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getUserMenu().then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var oldMenu, newList, oldList, isLargeScreenData, accessMenus, accessMenusList;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(res.status == 200)) {
                    _context.next = 23;
                    break;
                  }

                  oldMenu = JSON.parse(window.localStorage.getItem("Menu"));
                  _context.next = 4;
                  return dispatch("specialProcessing", res.data);

                case 4:
                  newList = res.data.map(function (i) {
                    return i.id;
                  });
                  oldList = oldMenu.map(function (i) {
                    return i.id;
                  });
                  store.commit("d2admin/permission/setFet", false);
                  _context.next = 9;
                  return store.dispatch("d2admin/db/get", {
                    dbName: "sys",
                    path: "user.islargeScreenData",
                    defaultValue: false,
                    user: true
                  }, {
                    root: true
                  });

                case 9:
                  isLargeScreenData = _context.sent;
                  _context.next = 12;
                  return store.dispatch("d2admin/permission/generateAccessMenus", res.data);

                case 12:
                  accessMenus = _context.sent;
                  accessMenusList = newList.length == oldList.length ? isLargeScreenData ? [{
                    path: "/largeScreenData",
                    title: "大屏数据",
                    icon: "signal"
                  }].concat(_toConsumableArray(accessMenus)) : accessMenus : []; // 设置顶栏菜单

                  store.commit("d2admin/menu/headerSet", [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenusList))); // 设置侧边栏菜单

                  store.commit("d2admin/menu/asideSet", [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenusList))); // 初始化菜单搜索功能

                  store.commit("d2admin/search/init", [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenusList)));
                  _context.next = 19;
                  return store.dispatch("d2admin/db/set", {
                    dbName: "sys",
                    path: "menu.accessMenus",
                    value: accessMenusList,
                    user: true
                  }, {
                    root: true
                  });

                case 19:
                  if (JSON.stringify(newList) != JSON.stringify(oldList)) {
                    store.dispatch("d2admin/serchSelect/setPageStatus", 2);
                  } else {
                    Message.success("重置成功");
                  }

                  loading.close();

                  _this._vm.$bus.$emit("upds");

                  store.dispatch("d2admin/page/closeAllt", {}, {
                    root: true
                  });

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 上报在线信息
     */
    reporting: function reporting() {
      if (process.env.NODE_ENV == 'development') {
        return;
      }

      window.timer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list, result, url, getTreeItem;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getTreeItem = function _getTreeItem(data, url) {
                  data.map(function (item) {
                    if (item.url == url) {
                      result = item; // 结果赋值
                    } else {
                      if (item.son_menu) {
                        getTreeItem(item.son_menu, url);
                      }
                    }
                  });
                };

                list = JSON.parse(window.localStorage.getItem("Menu"));
                result = "";
                url = router.history.current.path;
                getTreeItem(list, url);

                if (!(result || router.history.current.path == "/index")) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return updateUserState({
                  version: process.env.VUE_APP_VERSION_NEW
                }).then(function (res) {
                  if (res.code == 200) {
                    // if(process.env.NODE_ENV == 'production'){
                    // }
                    if (res.data != process.env.VUE_APP_VERSION_NEW) {
                      Message.error("版本已更新,即将刷新页面!");
                      setTimeout(function () {
                        window.location.reload();
                      }, 3000);
                    }
                  }
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 5000);
    },

    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref4) {
      var dispatch = _ref4.dispatch;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$email = _ref5.email,
          email = _ref5$email === void 0 ? "" : _ref5$email,
          _ref5$password = _ref5.password,
          password = _ref5$password === void 0 ? "" : _ref5$password,
          _ref5$verification_co = _ref5.verification_code,
          verification_code = _ref5$verification_co === void 0 ? "" : _ref5$verification_co,
          _ref5$key = _ref5.key,
          key = _ref5$key === void 0 ? "" : _ref5$key,
          _ref5$language = _ref5.language,
          language = _ref5$language === void 0 ? '' : _ref5$language;

      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response, reject) {
          var res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _login({
                    email: email,
                    password: password,
                    verification_code: verification_code,
                    key: key,
                    language: language
                  });

                case 2:
                  res = _context3.sent;

                  if (!(res.status == 200)) {
                    _context3.next = 13;
                    break;
                  }

                  _context3.next = 6;
                  return util.cookies.set("token", res.data.token);

                case 6:
                  _context3.next = 8;
                  return dispatch("specialProcessing", res.data.menu);

                case 8:
                  _context3.next = 10;
                  return dispatch("updUserInfo");

                case 10:
                  _context3.next = 12;
                  return dispatch("load");

                case 12:
                  dispatch("reporting");

                case 13:
                  response(res);

                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2, _x3) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    // 更新用户信息
    updUserInfo: function updUserInfo(_ref7) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var state, commit, dispatch, userInfo;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = _ref7.state, commit = _ref7.commit, dispatch = _ref7.dispatch;
                _context4.next = 3;
                return getInfo();

              case 3:
                userInfo = _context4.sent;
                _context4.next = 6;
                return dispatch("d2admin/user/set", {
                  name: userInfo.data.info.nickname,
                  id: userInfo.data.info.id,
                  roleId: userInfo.data.info.role_id,
                  isLogin: true
                }, {
                  root: true
                });

              case 6:
                _context4.next = 8;
                return store.dispatch("d2admin/user/setHomeShow", userInfo.data.info.is_show_home);

              case 8:
                _context4.next = 10;
                return store.dispatch("d2admin/user/gameShowType", userInfo.data.info.game_show_type);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 特殊权限管理
    specialProcessing: function specialProcessing(_ref8, list) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        // 项目汇总
        var index = list.findIndex(function (i) {
          return i.url == "special";
        });

        if (index > -1) {
          list.splice(index, 1);
        }

        var indexPI = list.findIndex(function (i) {
          return i.url == "/index";
        });

        if (indexPI > -1) {
          list.splice(indexPI, 1);
        } // 大屏数据


        var indexT = list.findIndex(function (i) {
          return i.url == "/largeScreenData";
        });

        if (indexT > -1) {
          list.splice(indexT, 1);
          var opened = store.state.d2admin.page.opened;
          var largeScreenData = {
            fullPath: "/largeScreenData",
            meta: {
              cache: true,
              auth: true,
              title: "大屏数据"
            },
            auth: true,
            cache: true,
            title: "大屏数据",
            name: "largeScreenData",
            params: {},
            path: "largeScreenData",
            query: {}
          };
          store.dispatch("d2admin/db/set", {
            dbName: "sys",
            path: "page.opened",
            value: [].concat(_toConsumableArray(opened), [opened.findIndex(function (i) {
              return i.name == "largeScreenData";
            }) > -1 ? [] : largeScreenData]),
            user: true
          }, {
            root: true
          });
        } // 项目汇总


        store.dispatch("d2admin/db/set", {
          dbName: "sys",
          path: "user.isSpecial",
          value: index > -1 ? true : false,
          user: true
        }, {
          root: true
        }); // 大屏

        store.dispatch("d2admin/db/set", {
          dbName: "sys",
          path: "user.islargeScreenData",
          value: indexT > -1 ? true : false,
          user: true
        }, {
          root: true
        }); //总览

        var indexOv = list.findIndex(function (i) {
          return i.url == "/overview";
        });
        console.log(indexOv);

        if (indexOv > -1) {
          list.splice(indexOv, 1);
        }

        store.commit('d2admin/user/SET_OV', indexOv > -1 ? true : false);
        window.localStorage.setItem("Menu", JSON.stringify(list));
        resolve();
      });
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
      }
    },
    /**
     * @description 退出登录用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref9) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref10$confirm = _ref10.confirm,
          confirm = _ref10$confirm === void 0 ? false : _ref10$confirm;

      /**
       * @description 退出登录
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  // 删除cookie
                  watermark.set("");
                  util.cookies.remove("token");
                  util.cookies.remove("uuid");
                  localStorage.clear(); // 清空 vuex 用户信息

                  _context5.next = 6;
                  return dispatch("d2admin/page/closeAll", {}, {
                    root: true
                  });

                case 6:
                  _context5.next = 8;
                  return dispatch("d2admin/user/set", {}, {
                    root: true
                  });

                case 8:
                  // 清除拖动数据
                  // store.commit("d2admin/serchSelect/setsericeArr", []);
                  store.commit("d2admin/system/setUnskipRoute", ""); // 清除筛选数据

                  store.dispatch("d2admin/serchSelect/clearData", 2); // 清除海盗数据

                  store.dispatch("gmTool/init/clearData");
                  store.commit("d2admin/permission/setFet", false);
                  store.commit("d2admin/user/SET_OV", false); // 清除侧边栏设置

                  store.dispatch("d2admin/db/set", {
                    dbName: "sys",
                    path: "menu.accessMenus",
                    value: [],
                    user: true
                  }, {
                    root: true
                  });
                  clearInterval(window.timer);
                  store.dispatch("d2admin/db/set", {
                    dbName: "sys",
                    path: "menu.Settings",
                    value: false,
                    user: true
                  }, {
                    root: true
                  });
                  window.localStorage.setItem("Menu", []); // 跳转路由

                  router.push({
                    name: "login"
                  });

                case 18:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit("d2admin/gray/set", true, {
          root: true
        });
        MessageBox.confirm("确定要退出登录吗", "退出登录", {
          type: "warning"
        }).then(function () {
          commit("d2admin/gray/set", false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit("d2admin/gray/set", false, {
            root: true
          });
          Message({
            message: "取消退出登录"
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref11) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var dispatch, state;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch = _ref11.dispatch, state = _ref11.state;
                _context6.next = 3;
                return dispatch("d2admin/user/load", null, {
                  root: true
                });

              case 3:
                if (util.cookies.get("token")) {
                  watermark.set("colocess - " + store.state.d2admin.user.info.name);
                } // 加载主题


                _context6.next = 6;
                return dispatch("d2admin/theme/load", null, {
                  root: true
                });

              case 6:
                _context6.next = 8;
                return dispatch("d2admin/transition/load", null, {
                  root: true
                });

              case 8:
                _context6.next = 10;
                return dispatch("d2admin/page/openedLoad", null, {
                  root: true
                });

              case 10:
                _context6.next = 12;
                return dispatch("d2admin/menu/asideLoad", null, {
                  root: true
                });

              case 12:
                _context6.next = 14;
                return dispatch("d2admin/size/load", null, {
                  root: true
                });

              case 14:
                _context6.next = 16;
                return dispatch("d2admin/color/load", null, {
                  root: true
                });

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};